"use client";

import { c as _c } from "react/compiler-runtime";
import { Skeleton } from "@website/ui/skeleton";
import { numberConvert } from "@website/utils/number-convert";
import { useCountDownTimer } from "@website/website-ui/hotel-last-second/count-down-timer/count-down-timer.hook";
import { FC } from "react";
export type CountDownTimerType = {
  className?: string;
  chipClassName?: string;
  showTimer?: boolean;
  onTimeEnd?: () => void;
  resetOnEnd?: boolean;
  boxSize?: "small" | "large";
};
export const CountDownTimerNewDesign: FC<CountDownTimerType> = t0 => {
  const $ = _c(28);
  const {
    showTimer: t1,
    onTimeEnd,
    resetOnEnd,
    className: t2,
    boxSize: t3
  } = t0;
  const showTimer = t1 === undefined ? true : t1;
  const className = t2 === undefined ? "" : t2;
  const boxSize = t3 === undefined ? "small" : t3;
  let t4;
  if ($[0] !== onTimeEnd || $[1] !== resetOnEnd) {
    t4 = {
      onTimeEnd,
      resetOnEnd
    };
    $[0] = onTimeEnd;
    $[1] = resetOnEnd;
    $[2] = t4;
  } else {
    t4 = $[2];
  }
  const {
    timeLeft
  } = useCountDownTimer(t4);
  if (timeLeft && showTimer) {
    const t5 = `mt-8 flex w-full justify-center gap-2 text-center ${className}`;
    const t6 = `flex ${boxSize === "small" ? "h-[28px] w-[38px]" : "size-10"} items-center justify-center rounded-lg bg-white`;
    const t7 = timeLeft?.hours;
    let t8;
    if ($[3] !== t7) {
      t8 = numberConvert(t7, {
        locale: "fa"
      });
      $[3] = t7;
      $[4] = t8;
    } else {
      t8 = $[4];
    }
    let t9;
    if ($[5] !== t6 || $[6] !== t8) {
      t9 = <div className={t6}>{t8}</div>;
      $[5] = t6;
      $[6] = t8;
      $[7] = t9;
    } else {
      t9 = $[7];
    }
    let t10;
    if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
      t10 = <div className="text-on-color-high-emphasis">:</div>;
      $[8] = t10;
    } else {
      t10 = $[8];
    }
    const t11 = `flex ${boxSize === "small" ? "h-[28px] w-[38px]" : "size-10"} items-center justify-center rounded-lg bg-white`;
    const t12 = timeLeft?.minutes;
    let t13;
    if ($[9] !== t12) {
      t13 = numberConvert(t12, {
        locale: "fa"
      });
      $[9] = t12;
      $[10] = t13;
    } else {
      t13 = $[10];
    }
    let t14;
    if ($[11] !== t11 || $[12] !== t13) {
      t14 = <div className={t11}>{t13}</div>;
      $[11] = t11;
      $[12] = t13;
      $[13] = t14;
    } else {
      t14 = $[13];
    }
    let t15;
    if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
      t15 = <div className="text-on-color-high-emphasis">:</div>;
      $[14] = t15;
    } else {
      t15 = $[14];
    }
    const t16 = `flex ${boxSize === "small" ? "h-[28px] w-[38px]" : "size-10"} items-center justify-center rounded-lg bg-white`;
    const t17 = timeLeft?.seconds;
    let t18;
    if ($[15] !== t17) {
      t18 = numberConvert(t17, {
        locale: "fa"
      });
      $[15] = t17;
      $[16] = t18;
    } else {
      t18 = $[16];
    }
    let t19;
    if ($[17] !== t16 || $[18] !== t18) {
      t19 = <div className={t16}>{t18}</div>;
      $[17] = t16;
      $[18] = t18;
      $[19] = t19;
    } else {
      t19 = $[19];
    }
    let t20;
    if ($[20] !== t14 || $[21] !== t19 || $[22] !== t9) {
      t20 = <div className="flex items-center justify-center gap-2 text-center"><span className="flex items-center gap-1" dir="ltr">{t9}{t10}{t14}{t15}{t19}</span></div>;
      $[20] = t14;
      $[21] = t19;
      $[22] = t9;
      $[23] = t20;
    } else {
      t20 = $[23];
    }
    let t21;
    if ($[24] !== t20 || $[25] !== t5) {
      t21 = <div className={t5}>{t20}</div>;
      $[24] = t20;
      $[25] = t5;
      $[26] = t21;
    } else {
      t21 = $[26];
    }
    return t21;
  }
  let t5;
  if ($[27] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <div className="h-[32px] w-full overflow-hidden rounded-full md:h-[28px] md:w-[145px]"><Skeleton height={32} /></div>;
    $[27] = t5;
  } else {
    t5 = $[27];
  }
  return t5;
};